export const getHideAboutPlan = ({ planId }: { planId?: string }) => !planId;
